import HTTP from "../../util/Http";
import { BASE_URL } from "../../util/Constants";
import {
  fetchFranjasHorarias,
  fetchAulasActivas,
  fetchOcupacionAulas,
} from "../Guardias/Guardias-Api";

export { fetchFranjasHorarias, fetchAulasActivas, fetchOcupacionAulas };

export async function fetchReservasAula(params = {}) {
  const query = new URLSearchParams();
  if (params.fecha) query.append("fecha", params.fecha);
  if (params.fechaInicio) query.append("fechaInicio", params.fechaInicio);
  if (params.fechaFin) query.append("fechaFin", params.fechaFin);
  if (params.franjaId) query.append("franjaId", params.franjaId);
  if (params.aulaId) query.append("aulaId", params.aulaId);
  if (params.profesorId) query.append("profesorId", params.profesorId);
  const url = BASE_URL + "reservas-aula" + (query.toString() ? `?${query.toString()}` : "");
  const response = await HTTP.get(url);
  return response.data;
}

export async function fetchMisReservasFuturas(profesorId) {
  const url = BASE_URL + `reservas-aula/profesor?profesorId=${profesorId}`;
  const response = await HTTP.get(url);
  return response.data;
}

export async function postReservarAula({ fecha, franjaId, aulaId, profesorId, motivo }) {
  const url = BASE_URL + "reserva-aula";
  const data = {
    fecha,
    franjaId,
    aulaId,
    profesorId,
    motivo: motivo || null,
  };
  const response = await HTTP.post(url, data);
  return response.data;
}

export async function deleteReservaAula(reservaId, profesorId) {
  const url = BASE_URL + `reserva-aula/${reservaId}?profesorId=${profesorId}`;
  const response = await HTTP.delete(url);
  return response.data;
}
